import CircularProgress from "@material-ui/core/CircularProgress";

export const withClaims = (Cmp) => (props) => {
  const { claims, fetchUserClaims, className, ...passThrough } = props;

  if (!claims.fetched) {
    if (!claims.fetching) fetchUserClaims();

    return (
      <div className={className + " loader-wrapper"}>
        <CircularProgress />
      </div>
    );
  }

  return <Cmp {...passThrough} claims={claims} className={className} />;
};
